import { render } from "./ASMSSystem.vue?vue&type=template&id=213da89e&scoped=true"
import script from "./ASMSSystem.vue?vue&type=script&lang=js"
export * from "./ASMSSystem.vue?vue&type=script&lang=js"

import "./ASMSSystem.vue?vue&type=style&index=0&id=213da89e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213da89e"]])

export default __exports__